import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Slice } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useSite } from '@shapeable/ui';
const cls = classNames('slice-indigenous-voices-storymap');

// -------- Types -------->

export type IndigenousVoicesStorymapIframeProps = Classable & HasChildren & {
};

export const IndigenousVoicesStorymapIframeDefaultProps: Omit<IndigenousVoicesStorymapIframeProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

type IframeProps = {
  headerHeightMobile: number;
  headerHeightTablet: number;
  headerHeightDesktop: number;
}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    
  `,
});

const IframeStyles = breakpoints({
  base: css`
    width: 100%;
    ${({ headerHeightMobile }: IframeProps) => css`
      min-height: calc(100vh - ${headerHeightMobile}px);
    `}
  `,
  tablet: css`
    ${({ headerHeightTablet }: IframeProps) => css`
      min-height: calc(100vh - ${headerHeightTablet}px);
    `}
  `,
  desktop: css`
    ${({ headerHeightDesktop }: IframeProps) => css`
      min-height: calc(100vh - ${headerHeightDesktop}px);
    `}
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Iframe: styled.iframe<IframeProps>`${IframeStyles}`,

};

export const IndigenousVoicesStorymapIframe: Shapeable.FC<IndigenousVoicesStorymapIframeProps> = (props) => {
  const { className, children } = props;

  const site = useSite();

  return (
    <My.Container className={cls.name(className)}>
        <My.Iframe
        headerHeightMobile={site.headerHeightMobile || 64}
        headerHeightTablet={site.headerHeightTablet || 78}
        headerHeightDesktop={site.headerHeightDesktop || 100}
        src="https://storymaps.arcgis.com/stories/40b41baa5f9947dcb9dbfd2144154851"
        title="Indigenous Voices Storymap"
        allowFullScreen
        />
    </My.Container>
  );
};

IndigenousVoicesStorymapIframe.defaultProps = IndigenousVoicesStorymapIframeDefaultProps;
IndigenousVoicesStorymapIframe.cls = cls;

// Banner 'Artwork'